import { withLocalizedResourceFetch } from "@devowl-wp/deliver-anonymous-asset";
import { getAnonymousLocalizedScript } from "@devowl-wp/utils";
/**
 * Use this if you do not have the Mobx store available in your JavaScript asset.
 * E. g. the `banner.js` does not rely on the mobx store and should access the
 * localized options via `window.realCookieBanner` directly.
 */ function getOptionsFromWindow() {
    const options = getAnonymousLocalizedScript(process.env.slug);
    if (!options) {
        throw new Error("Localized options are not available on window.");
    }
    return withLocalizedResourceFetch(options);
}
export { getOptionsFromWindow };
